import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import BottomNavBar from "../components/generalComponents/BottomNavBar";
import Header from "../components/generalComponents/Header";
import ScannerAdd from "../components/scanner/ScannerAdd";
import ScannerOverlay from "../images/scanner.svg";

const useStyles = makeStyles((theme) => ({
  scannerAddBarcode: {
    borderRadius: "8px",
    overflow: "hidden",
    position: "relative",
    width: "100%",
    height: "600px",
    "&::before": {
      content: '""',
      position: "absolute",
      borderRadius: "5px",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      backgroundImage: `url(${ScannerOverlay})`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundSize: "contain",
    },
    "& video": {
      objectFit: "cover",
    },
  },
}));

export default function AddBarcodeScannerView(props) {
  const classes = useStyles();

  return (
    <div className={"pageWrapper"}>
      <Header title="Barcode toevoegen" needsLocation="Yes" />
      <div className={"scanner"}>
        <ScannerAdd />
      </div>
      <BottomNavBar />
    </div>
  );
}
